import { render, staticRenderFns } from "./AddCounter.vue?vue&type=template&id=9052df18"
import script from "./AddCounter.vue?vue&type=script&lang=js"
export * from "./AddCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports